var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 5@3x"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Thumbnails/metadata","transform":"translate(-435.000000, -4.000000)","stroke":"#979797"},React.createElement("g",{"id":"Group-7","transform":"translate(0.000000, -3.000000)"},React.createElement("g",{"id":"Group-5","transform":"translate(435.000000, 8.000000)"},[React.createElement("polyline",{"id":"Path-63","points":"11 0 20 7.5 11 15","key":0}),React.createElement("line",{"x1":"20","y1":"7.5","x2":"0","y2":"7.5","id":"Path-64","key":1})]))))]);
}

ArrowRight.defaultProps = {"width":"20px","height":"17px","viewBox":"0 0 20 17","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
